import portraitImage from '../assets/portrait.jpg';

export function About() {
  return (
    <section id="about" className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-12">
            <div className="space-y-8">
              <h2 className="text-4xl">Rólam</h2>
              <div className="space-y-6">
                <p>
                  Berekvölgyi Dorottya vagyok, de nyugodtan hívhatsz Dorkának is.
                </p>
                
                <p>
                  Lélekben még mindig az a falusi kislány vagyok, aki nagyokat álmodott — és most, a YOGIVITY programmal, végre megvalósítottam az egyik legnagyobb álmomat.
                </p>
                
                <p>
                  Néhány apró érdekesség rólam, hogy jobban megismerj: A reggeli kávém az én szent kis időm. Olyankor csendben olvasgatok, tervezgetek, magamra hangolódom.
                </p>
                
                <p>
                  Lélekben egy igazi nagymama vagyok: imádok sütni, főzni, olvasni, időben lefeküdni, nem kapkodni, növényeket gondozni, és időről időre technológiamentes napokat beiktatni.
                </p>
              </div>
            </div>

            <div className="space-y-8">
              <h2 className="text-4xl">Én és a YOGIVITY</h2>
              <div className="space-y-6">
                <p>
                  Sokáig próbáltam „jól csinálni" a dolgokat – helyesen étkezni, karbantartani a testemet, jól lenni. De valahogy mindig ott maradt bennem egy belső feszültség, hogy nem tudom, mi az, ami igazán nekem való.
                </p>
                
                <p>
                  A YOGIVITY azért született meg, hogy legyen egy hely, ahol a testtel és a lélekkel egyszerre lehet foglalkozni – türelmesen, egyszerűen, hosszú távon.
                </p>
                
                <p>
                  Hiszek abban, hogy minden valódi változás belül kezdődik, és kívül is láthatóvá válik. Mindenki megérdemli, hogy a teste az otthona legyen, ne a harctere.
                </p>
                
                <p>
                  Jógatanárként és étkezési tanácsadóként olyan programokat alkotok, amelyek nem nyomnak rád újabb elvárásokat – inkább segítenek visszatalálni önmagadhoz.
                </p>
                
                <p>
                  Ha úgy érzed, itt az idő másképp törődni magaddal, örömmel kísérlek ezen az úton.
                </p>
              </div>
            </div>
            
            <div className="flex justify-center">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-2xl">
                <div className="space-y-4 text-center">
                  <h4 className="text-lg">Tanúsítványaim</h4>
                  <div className="space-y-3">
                    <p className="text-muted-foreground">200 órás jógatanári képzés</p>
                    <p className="text-muted-foreground">Étkezési Tanácsadó</p>
                    <p className="text-muted-foreground">Közgazdász</p>
                  </div>
                </div>
                <div className="space-y-4 text-center">
                  <h4 className="text-lg">Szakterületeim</h4>
                  <div className="space-y-3">
                    <p className="text-muted-foreground">Biológiai fiatalság</p>
                    <p className="text-muted-foreground">Stresszkezelés</p>
                    <p className="text-muted-foreground">Erősítés, Nyújtás</p>
                    <p className="text-muted-foreground">Kiegyensúlyozott étkezés</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="w-full">
            <div className="h-[800px] rounded-3xl overflow-hidden">
              <img
                src={portraitImage}
                alt="Berekvölgyi Dorottya portréja"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}